var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 116,
    viewBox: "0 0 153 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8049 69.8232C37.9772 61.2806 53.4453 48.7889 68.9039 36.9114C81.0536 27.5763 93.7267 18.2772 106.864 9.92429C109.456 8.2761 113.233 5.12037 116.313 5.94018C119.365 6.75256 120.774 9.73711 123.052 11.3428C128.662 15.2971 133.496 20.3555 137.88 25.2497C142.705 30.6374 133.748 34.9214 127.948 39.4521C121.361 44.5985 115.022 49.8548 107.957 54.5361C101.242 58.9859 95.5454 64.7205 89.2847 69.6078C79.743 77.0561 70.7018 84.8607 61.1842 92.3128C55.5185 96.749 49.1959 100.561 43.7009 105.113C41.7755 106.708 39.9172 108.739 37.7592 110.129C36.0261 111.246 34.3096 107.891 33.8336 107.276C30.055 102.396 23.5528 99.4961 19.9028 94.3579C17.608 91.1273 16.3407 86.965 13.4538 84.1034C12.0756 82.7373 8.57666 79.7068 10.6359 77.2552C12.7384 74.7521 17.9513 73.0818 20.9406 71.123C23.2708 69.596 26.1069 67.7154 28.6796 66.5469C30.5494 65.6978 32.4566 64.3502 34.1715 63.2848C38.6844 60.4809 34.1075 61.9759 31.1543 63.1607",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9681 80.1045C30.7425 84.1576 39.1098 90.6701 46.2696 97.2152C46.451 97.381 48.2907 98.276 47.9288 98.7241C47.2302 99.5891 40.9159 96.7445 40.315 96.456",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4316 71.3787C40.6734 72.3862 45.2284 75.5492 51.5473 78.7716C54.362 80.207 57.2576 81.4626 59.7151 83.246C60.8691 84.0834 61.6083 85.2736 62.6534 86.199C64.0858 87.4673 57.8478 85.0785 57.1119 84.8053",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6208 64.1323C50.9772 67.7902 56.3732 71.3848 61.9407 74.8479C64.0558 76.1635 66.5046 77.3141 68.2623 78.9457C71.3826 81.8422 67.2906 78.0885 65.8667 77.059",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5436 59.0745C58.6625 60.7406 62.9875 62.3179 66.3241 64.813C67.6928 65.8364 68.7702 67.1028 70.2573 68.0264C72.0892 69.1641 73.6388 70.5573 75.4894 71.6553C78.1246 73.219 78.4836 73.7215 75.3707 71.7372",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1896 51.5229C70.6384 54.046 74.7172 56.6574 78.2732 59.9448C79.8482 61.4007 81.0369 63.1519 83.1517 64.1673C85.089 65.0977 86.5137 65.2696 84.3196 63.6509",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4517 43.8948C81.3838 46.0086 85.2868 47.9032 88.2509 50.861C89.6079 52.215 90.6025 53.8345 92.1593 55.0492C95.3206 57.5159 93.0733 56.3456 90.7687 54.6892",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9421 36.1138C93.324 40.0764 97.6159 44.9429 103.016 48.8474C106.653 51.4765 101.515 47.1864 100.685 46.415",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.353 29.4719C105.659 27.2377 111.198 24.6625 114.492 20.286C115.4 19.0791 116.504 17.9934 116.99 16.6936C117.656 14.9086 117.469 15.6632 115.711 16.9669",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M107.742 34.1607C112.182 30.7083 117.135 26.9257 120.613 22.785C122.348 20.7198 125.471 18.0862 121.173 21.2737",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M119.76 39.0088C123.871 35.3953 127.547 32.0511 131.387 28.324C132.627 27.1198 136.143 25.3438 132.029 26.6498",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.07 37.7167C121.275 34.6433 126.041 31.0793 129.546 27.4005C130.481 26.4192 131.243 25.3573 132.114 24.3488C133.574 22.6596 133.58 23.1741 131.671 23.5446",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5809 84.2856C50.5614 75.9016 57.6363 58.4278 74.5445 47.1003C76.6014 45.7223 78.3208 44.2541 80.6425 43.1998C82.1949 42.4947 84.0551 42.0322 85.4959 41.1911C86.3749 40.678 93.769 35.7301 88.7946 37.9892",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3136 80.7503C24.7503 78.4127 26.9043 76.4044 29.8363 74.5827C30.3172 74.284 31.0116 74.1649 31.4248 73.7915C32.2435 73.0518 33.479 71.966 33.8774 71.0856C35.4465 67.6181 40.7524 67.6326 43.8491 65.6353C46.7949 63.7352 49.6419 61.8269 52.6381 59.94C55.9391 57.8612 57.5664 56.1801 60.3331 53.6802C62.8746 51.3839 65.3533 49.0714 68.0117 46.8692C70.1864 45.0676 73.4578 43.2843 74.9838 41.1193C76.7061 38.6759 80.6585 35.6575 83.8292 35.7196C84.9183 35.7409 92.5402 38.627 87.5508 36.7946",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4687 86.9875C53.6782 79.2866 63.4979 65.1106 74.5949 53.99C78.6823 49.894 84.1301 46.8662 88.3755 42.8158C90.1914 41.0833 93.9537 39.0378 89.8416 39.5245",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0729 90.1758C56.9815 82.2843 66.9805 69.3801 77.7691 58.8332C82.6773 54.035 87.4481 49.163 92.4043 44.394C94.664 42.2197 98.2998 40.6124 93.5737 43.1088",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2637 96.3165C56.2707 89.0384 63.7835 81.4317 71.4532 73.3207C76.1169 68.3888 80.3102 62.9625 85.6156 58.3979C88.6597 55.7789 91.1326 52.8344 93.9453 50.1042C95.0784 49.0044 95.9256 47.7759 97.0851 46.6812C99.697 44.2154 97.8122 46.3927 96.0408 47.77",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7854 98.8937C53.2696 95.2575 59.6169 91.5302 62.8878 87.0985C64.0753 85.4895 67.0014 81.5983 68.8275 80.4906C71.2416 79.0264 72.6708 76.3264 74.5311 74.5207C76.4683 72.6404 78.364 70.8048 80.4345 68.9908C82.376 67.2897 83.2988 64.5824 85.6232 63.0453C88.2125 61.3329 89.6859 58.9662 91.8311 57.0279C93.6878 55.3502 97.042 53.4517 99.2464 52.0821C100.468 51.3233 101.379 50.3733 102.73 49.7598C105.468 48.5163 103.709 49.1928 101.334 49.3882",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8597 30.7014C103.104 31.0359 107.158 31.0611 110 32.1851C111.834 32.9105 113.414 33.6682 110.074 32.3472",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.957 25.8247C108.586 26.2927 111.799 27.0385 115.404 28.6421C117.761 29.6906 117.404 29.3671 114.934 28.3805",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.37 20.6492C114.207 22.0428 117.887 23.7028 121.896 24.8413C124.255 25.5108 122.957 25.5909 121.139 25.0597",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.17 16.6614C118.256 17.756 122.006 18.8817 125.694 20.4212C127.376 21.1233 125.727 21.3655 124.458 20.7871",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M102.191 28.8885C105.877 25.4137 109.551 22.1008 112.957 18.5808C113.924 17.5808 119.752 11.9634 117.177 14.7927",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.849 33.9664C109.5 30.4829 116.159 25.7873 118.151 21.1381C118.737 19.7698 119.793 18.3497 121.198 17.2964C122.622 16.2281 124.035 15.6595 121.883 17.4322",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.468 34.2446C106.526 29.8296 110.749 26.7699 113.969 21.6683C114.805 20.3434 115.709 19.2217 116.933 18.1157C118.23 16.9437 120.02 15.7817 117.535 17.898",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M117.969 34.2922C119.9 35.1192 121.847 35.8679 123.884 36.5079C124.725 36.7722 123.72 36.1909 123.357 36.1189",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.749 28.6025C122.876 28.6828 130.262 33.3983 128.988 32.3048",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M127.885 26.0178C129.493 27.2107 134.445 30.6714 132.678 29.6229",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M115.245 36.7861C118.544 34.2147 125.711 29.0492 127.795 25.431C128.616 24.0051 131.755 21.9395 128.771 24.1075",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.528 37.4113C115.787 37.5622 120.81 41.8712 122.363 39.3352C123.155 38.0408 124.187 36.3548 125.806 35.5089C128.647 34.0248 129.66 30.2392 132.539 28.9319C135.805 27.4487 135.78 25.5776 132.98 25.2265C131.879 25.0886 133.027 23.1859 131.827 23.4598C130.728 23.7105 130.2 23.4536 128.966 23.7672",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5758 30.0765C101.116 32.8683 101.334 33.9186 104.321 34.8204C105.127 35.0638 106.306 34.469 106.917 34.6609C108.125 35.0406 110.656 34.7679 111.745 33.7112C113.934 31.5864 114.813 30.2748 117.922 28.7833C119.883 27.8424 121.618 25.9461 122.678 24.4166C123.843 22.7357 125.711 21.3581 126.929 19.6652C127.448 18.9444 124.259 17.5945 124.39 16.4332C124.427 16.1039 120.355 16.5502 119.716 16.3493C118.941 16.106 118.631 15.6756 118.334 15.0218C117.9 14.067 116.703 15.4469 115.143 15.7167",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4089 75.8735C30.8397 76.77 34.6214 78.1421 38.5068 79.6943C41.88 81.0419 45.8377 81.518 49.1955 82.8143C51.586 83.7372 53.8571 86.2009 55.4931 87.8029C56.0382 88.3366 56.4294 88.8494 56.7809 89.4805C57.5872 90.9282 57.0479 87.2703 56.9971 86.8685",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0515 42.4707C76.1839 43.4107 80.5474 48.8115 80.1484 44.4294",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.6df30ad16bf7d0c16f13b4fc24f64d06.svg";
export { ForwardRef as ReactComponent };